export default "__VITE_ASSET__CQQfMwDw__"